import { formatPrice, Price } from './format/price';

export const calculatePricePerPackage = (price: Price, packageSize: number, referencePackagePrice: number) => {
	const value = (Number(price.value) / packageSize) * referencePackagePrice;
	return formatPrice({ value: String(value), currency: price.currency });
};
